import React from 'react';
import './Footer.css';
import logo from '../assets/image.png'; 

import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,  
  FaInstagram,
  FaLinkedinIn
} from 'react-icons/fa';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-col company-info">
        <img src={logo} alt="Technologies" style={{ height: '50px', filter: 'invert(100%) grayscale(100%) brightness(200%)' }} />

          <p>
            
           Empowering businesses worldwide with custom software development, ERP solutions, AI innovation, and digital transformation services.
          </p>
          <div className="contact-item">
        <FaPhone className="contact-icon" />
        <a href="tel:+91 98904 13967">+91 98904 13967</a>
      </div>

      <div className="contact-item">
        <FaEnvelope className="contact-icon" />
        <a href="mailto:support@hitentechnologies.com">support@hitentechnologies.com</a>
      </div>

      <div className="contact-item">
        <FaMapMarkerAlt className="contact-icon" />
          <a 
    href="https://maps.app.goo.gl/LKQpkrpBB7YoiL5h7" 
    target="_blank" 
    rel="noopener noreferrer"
    className="contact-address"
  >
    Flat No 304, B Wing, Rajveer Galaxy Sr No 3 Samarth Nagar Dighi, Pune, Maharashtra 411015
    
  </a>

      </div>

      <h4>Follow Us</h4>
      <div className="social-icons">
        <a href="https://www.facebook.com/HitenTechnologies/" target="_blank" rel="noopener noreferrer">
          <FaFacebookF />
        </a>        
        <a href="https://www.instagram.com/hitentechnologies/" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
        <a href="https://www.linkedin.com/company/hiten-technologies/" target="_blank" rel="noopener noreferrer">
          <FaLinkedinIn />
        </a>
       
      </div>
        </div>

        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            <li><a href="/services#software">Custom Software Development</a></li>
            <li><a href="/services#web-mobile">Web & Mobile App </a></li>
            <li><a href="/services#erp-sap">ERP & SAP Services</a></li>
            <li><a href="/services#cloud-devops"> Cloud & DevOps Solutions</a></li>
             <li><a href="/services#ai-analytics">AI & Data Analytics</a></li>
            <li><a href="/services#marketing-seo">Digital Marketing & SEO</a></li>
            <li><a href="/services#consulting">IT Consulting & Digital Transformation</a></li>
            <li><a href="/services#ui-ux">UI/UX & Product Design</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li><a href="/">Home</a></li>           
             <li><a href="/about">About Us</a></li> 
            <li><a href="/services">Services</a></li>            
            <li><a href="/contact">Contact</a></li>
            
          </ul>
        </div>

        <div className="footer-col">
          <h4>Resources</h4>
          <ul>
            <li><a href="/support">Support Center</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/terms">Terms of Service</a></li>
            
            
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} All rights reserved.</p>
        <div className="footer-links">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          
        </div>
      </div>
    </footer>
  );
}

export default Footer;
